/** Served from `public/images/logo.png` */
export const LOGO_SRC = '/images/logo.png'

export const LOGO_ALT = 'Shiny Touch Painting & Renovation Ltd'
